import React, { useState, useRef, useEffect } from 'react';
import { User, ChevronDown, LogOut } from 'lucide-react';

const Header = ({ storeInfo, onLogout, onMyPageClick, canInstall, onInstallClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  // 외부 클릭 시 드롭다운 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleMyPageClick = () => {
    setIsDropdownOpen(false);
    onMyPageClick();
  };

  const handleLogoutClick = () => {
    setIsDropdownOpen(false);
    onLogout();
  };

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* 로고 및 제목. 안드로이드 크롬처럼 설치 가능한 상태일 때만
              누를 수 있게 한다(canInstall) - 이미 앱으로 설치했거나
              아이폰이면 눌러도 반응이 없을 이유가 없다. */}
          <button
            type="button"
            onClick={canInstall ? onInstallClick : undefined}
            disabled={!canInstall}
            className={`flex items-center space-x-3 min-w-0 flex-1 text-left ${canInstall ? 'cursor-pointer' : 'cursor-default'}`}
            title={canInstall ? '앱으로 설치하기' : undefined}
          >
            <img src="/logo192.png" alt="뽀짝" className="w-8 h-8 sm:w-10 sm:h-10 flex-shrink-0" />
            <div className="min-w-0 flex-1">
              <h1 className="text-lg sm:text-xl font-bold text-gray-900 truncate">뽀짝 스탬프 적립</h1>
              <p className="text-xs sm:text-sm text-gray-500 truncate">{storeInfo.storeName} 관리자</p>
            </div>
          </button>

          {/* 데스크톱: 버튼들 / 모바일: 드롭다운 */}
          <div className="flex items-center">
            {/* 데스크톱 버전 (md 이상에서 표시) */}
            <div className="hidden md:flex items-center space-x-3">
              <button 
                onClick={onMyPageClick}
                className="bg-gray-100 hover:bg-blue-50 text-gray-700 hover:text-blue-600 text-sm font-medium px-3 py-2 rounded-lg transition-all duration-200 active:scale-95 flex items-center space-x-1"
              >
                <User className="w-4 h-4" />
                <span>마이페이지</span>
              </button>
              <button 
                onClick={onLogout}
                className="bg-gray-100 hover:bg-red-50 text-gray-700 hover:text-red-600 text-sm font-medium px-3 py-2 rounded-lg transition-all duration-200 active:scale-95"
              >
                로그아웃
              </button>
            </div>

            {/* 모바일 버전 (md 미만에서 표시) */}
            <div className="md:hidden relative" ref={dropdownRef}>
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 p-2 rounded-lg transition-all duration-200 active:scale-95 flex items-center space-x-1"
              >
                <User className="w-5 h-5" />
                <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`} />
              </button>

              {/* 드롭다운 메뉴 */}
              {isDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <button
                    onClick={handleMyPageClick}
                    className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 flex items-center space-x-2"
                  >
                    <User className="w-4 h-4" />
                    <span>마이페이지</span>
                  </button>
                  <hr className="my-1 border-gray-200" />
                  <button
                    onClick={handleLogoutClick}
                    className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 flex items-center space-x-2"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>로그아웃</span>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;